exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".scrollX {\n  overflow-x: scroll; }\n\n.scrollY {\n  overflow-y: scroll; }\n", "", {"version":3,"sources":["/Users/junya/sunnyeee/sciseed/sAIFaqAdmin/src/main.scss"],"names":[],"mappings":"AAMA;EACE,mBAAkB,EACnB;;AAED;EACE,mBAAkB,EACnB","file":"main.scss","sourcesContent":["// * {\n//   &::-webkit-scrollbar {\n//     display: none;\n//   }\n// }\n\n.scrollX {\n  overflow-x: scroll;\n}\n\n.scrollY {\n  overflow-y: scroll;\n}\n\n// @-moz-document url-prefix() {\n//   .scrollX,\n//   .scrollY {\n//     overflow: hidden !important;\n//   }\n// }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/postcss-loader/lib??ref--6-2!./node_modules/sass-loader/lib/loader.js??ref--6-3!./src/main.scss
// module id = hbWF
// module chunks = 0